<template>
  <b-col
    id="main-panel"
    cols="auto"
    class="d-flex flex-column px-0 flex-shrink-1 flex-grow-1 mh-100 main-panel"
  >
    <template v-if="!appLoaded">
      <Spinner data-test="loading-spinner" />
    </template>
    <template v-else>
      <template v-if="!hideHeader">
        <HeaderPanel :panel="headerPanel" />
        <AddressResult />
      </template>
      <b-row
        no-gutters
        class="w-100 mw-100 h-100 mh-100 minimum-height"
      >
        <b-col class="d-flex flex-column px-0 mh-100">
          <slot />
        </b-col>
      </b-row>
    </template>
  </b-col>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import Spinner from '@/components/public/Spinner.vue'

import AddressResult from '@/components/public/AddressResult.vue'
import HeaderPanel from '@/components/public/DesktopLayout/HeaderPanel.vue'

const components = {
  Spinner,
  AddressResult,
  HeaderPanel,
}

const props = {
  hideHeader: Boolean,
  headerPanel: {
    type: String,
    required: true,
  },
}

@Component({ components })
export default class MainPanel extends Vue.extend({ props }) {
  get appLoaded () {
    return this.$typedStore.activeVisualisation.appLoaded
  }
}

</script>
